import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, apiPut } from "@/lib/api";

const orgSettingsKeys = {
  all: ["org-settings"] as const,
};

export function useOrgSettings() {
  return useQuery({
    queryKey: orgSettingsKeys.all,
    queryFn: () => apiFetch<Record<string, string>>("/admin/settings"),
  });
}

export function useUpdateOrgSetting() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ key, value }: { key: string; value: string }) =>
      apiPut(`/admin/settings/${key}`, { value }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: orgSettingsKeys.all });
      toast.success("Setting saved");
    },
    onError: () => toast.error("Failed to save setting"),
  });
}
